import type { ComponentType } from 'react';
import React from 'react';
import { AdminManagementLayout } from '../admin-management-layout';

export const HelpCenterManageProjects: ComponentType = () => (
    <AdminManagementLayout featureName="Helpcenter manage projects">
        <div>Manage Projects</div>
    </AdminManagementLayout>
);
